(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ke-video-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ke-video-carousel')) {
    customElements.define('ke-video-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ke-videos__track');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const step = direction => {
          const card = this.track.querySelector('[data-video-card]');
          if (!card) return;
          this.track.scrollBy({ left: direction * (card.offsetWidth + parseFloat(getComputedStyle(this.track).gap)), behavior: this.motion() });
        };
        this.previous.addEventListener('click', () => step(-1), { signal });
        this.next.addEventListener('click', () => step(1), { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            step(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.track.addEventListener('scroll', () => this.updateProgress(), { passive: true, signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-play], [data-fullscreen]');
          if (!button || !this.contains(button)) return;
          const card = button.closest('[data-video-card]');
          if (button.hasAttribute('data-fullscreen') && card.querySelector('dialog[open]')) {
            card.querySelector('dialog[open]').close();
            return;
          }
          const coverButton = card.querySelector('[data-play]');
          let video = card.querySelector('video');
          if (video && button.hasAttribute('data-fullscreen')) {
            this.toggleFullscreen(card, video);
            return;
          }
          if (!video) {
            card.querySelector('.ke-videos__media').append(card.querySelector('template').content.cloneNode(true));
            video = card.querySelector('video');
          }
          const error = card.querySelector('.ke-videos__error');
          error.hidden = true;
          this.pauseOthers(video);
          coverButton.hidden = true;
          const fail = () => {
            video.pause();
            video.remove();
            coverButton.hidden = false;
            error.textContent = this.dataset.error;
            error.hidden = false;
          };
          video.addEventListener('error', fail, { once: true, signal });
          const sources = Array.from(video.querySelectorAll('source'));
          const failedSources = new Set();
          sources.forEach(source => source.addEventListener('error', () => {
            failedSources.add(source);
            if (sources.every(item => failedSources.has(item) || (item.type && !video.canPlayType(item.type)))) fail();
          }, { once: true, signal }));
          if (button.hasAttribute('data-fullscreen')) this.toggleFullscreen(card, video);
          const play = video.play();
          if (play) play.then(() => video.focus()).catch(fail);
        }, { signal });
        document.addEventListener('fullscreenchange', () => {
          this.querySelectorAll('[data-fullscreen]').forEach(button => {
            const active = document.fullscreenElement === button.closest('.ke-videos__media');
            button.setAttribute('aria-label', active ? button.dataset.exitLabel : button.dataset.enterLabel);
          });
        }, { signal });
        this.addEventListener('play', event => this.pauseOthers(event.target), { capture: true, signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseOthers();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-video-card]');
          if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: this.motion() });
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) entry.target.querySelector('video')?.pause();
          });
        }, { threshold: 0 });
        this.querySelectorAll('[data-video-card]').forEach(card => this.observer.observe(card));
        this.resize = new ResizeObserver(() => this.updateProgress());
        this.resize.observe(this.track);
        this.updateProgress();
      }
      toggleFullscreen(card, video) {
        const media = card.querySelector('.ke-videos__media');
        const dialog = media.closest('dialog');
        if (dialog) {
          dialog.close();
        } else if (document.fullscreenElement === media) {
          document.exitFullscreen()?.catch(() => {});
        } else if (media.requestFullscreen) {
          media.requestFullscreen().catch(() => this.openExpanded(card, media));
        } else if (video.webkitEnterFullscreen) {
          const enter = () => { try { video.webkitEnterFullscreen(); } catch (_) { this.openExpanded(card, media); } };
          if (video.readyState >= 1) enter();
          else video.addEventListener('loadedmetadata', enter, { once: true, signal: this.controller.signal });
        } else {
          this.openExpanded(card, media);
        }
      }
      openExpanded(card, media) {
        if (!this.isConnected || media.closest('dialog')) return;
        const dialog = document.createElement('dialog');
        const button = media.querySelector('[data-fullscreen]');
        const previousMinHeight = card.style.minHeight;
        card.style.minHeight = card.offsetHeight + 'px';
        dialog.className = 'ke-videos__dialog';
        dialog.setAttribute('aria-label', button.dataset.enterLabel);
        media.before(dialog);
        dialog.append(media);
        button.setAttribute('aria-label', button.dataset.exitLabel);
        dialog.addEventListener('close', () => {
          dialog.before(media);
          dialog.remove();
          card.style.minHeight = previousMinHeight;
          button.setAttribute('aria-label', button.dataset.enterLabel);
          button.focus({ preventScroll: true });
        }, { once: true });
        dialog.showModal();
        button.focus({ preventScroll: true });
      }
      updateProgress() {
        const width = this.track.clientWidth;
        const total = this.track.scrollWidth;
        const max = total - width;
        const position = Math.max(0, Math.min(max, this.track.scrollLeft));
        this.style.setProperty('--ke-thumb-width', (total ? width / total * 100 : 100) + '%');
        this.style.setProperty('--ke-thumb-x', (width ? position / width * 100 : 0) + '%');
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= max - 1;
        this.querySelector('.ke-videos__navigation').hidden = max <= 1;
      }
      pauseOthers(current) {
        document.querySelectorAll('ke-video-carousel video').forEach(video => {
          if (video !== current) video.pause();
        });
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach(video => video.pause());
        this.controller?.abort();
        this.controller = null;
        this.resize?.disconnect();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
